import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutMediaFormFields {

    public name: FormField
    public description: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )

    }
}

const fields = new PutMediaFormFields()

export const putMediaFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
};